import { fetchFromAPI } from 'utils/api';

export const downloadTreatmentEfficacyCSV = (id) => {
  return fetchFromAPI(`/treatment_efficacies/${id}/csv`, { blob: true })
    .catch((response) => {
      throw response;
    });
};
